import { Spin, Space } from "antd";

const Loader = () => {
  return (
    <Space size="middle">
      <Spin size="large" />
    </Space>
  );
};

export default Loader;
